export default class Text {
    constructor(idioma) {
        this.idioma = idioma || 'br'
    }

    getTextoHeader() {
        switch (this.idioma) {
            case 'br': 
                return `Oferecemos o que há de melhor em infraestrutura de TI e software`
            case 'us':
                return `We offer the best in infrastructure and software`
            default: 
                return `Undefined Language`
        }        
    }

    getTextoHome1() {

        switch (this.idioma) {
            case 'br':
                return `Atuando no mercado de Infraestrutura de TI e Desenvolvimento Web, a City Connect possui uma larga experiência no mercado, aplicando soluções viáveis e que se sobressaem como modelos de gestão em comércio, fábricas e setores públicos desde 2010`
            case 'us':
                return `Working on T.I. Infrastrutuce and Web Development, City Connect has a wide experience on market, applying viable solutions wich stand out as management models in commerce, factories and public sections since 2010`
            default:
                return `Undefined Language`
        }
    }

    getTituloResumo1() {
        switch (this.idioma) {
            case 'br':
                return `Confiam em nosso serviço`
            case 'us':
                return `Who trust our services`
            default:
                return `Undefined Language`
        }
    }

    getButtonMoreText(){
        switch (this.idioma) {
            case 'br':
                return `Conheça alguns projetos`
            case 'us':
                return `See some of our projects`
            default:
                return `Undefined Language`
        }
    }

    getTituloResumo2() {
        switch (this.idioma) {
            case 'br':
                return `Fique tranquilo com os dados pessoais e \n informações importantes de sua empresa.`
            case 'us':
                return `Rest assured about all your data, being it your own or of your business`
            default:
                return `Undefined Language`
        }
    }

    getTopico1() {
        switch (this.idioma) {
            case 'br':
                return `Larga experiência no fornecimento de serviços para redes sem fio, fornecendo consultoria, venda e Mão de obra e wireless.`
            case 'us':
                return `Large experience in providing services for wireless networks, providing consulting, sales and labor and wireless.`
            default:
                return `Undefined Language`    
        }
    }

    getTopico2() {
        switch (this.idioma) {
            case 'br':
                return `Soluções em telecomunicações, telefonia e interfonia para empresas, condomínios e até mesmo residências.`
            case 'us':
                return `Solutions in telecommunications, telephony and intercom for companies, condominium and even residences.`
            default:
                return `Undefined Language`    
        }
    }

    getTopico3() {
        switch (this.idioma) {
            case 'br':
                return `Montagem de servidores web, arquivos, firewall, dedicados, domínio, redundância e backup.`
            case 'us':
                return `Web servers, files, firewall, dedicated, domain, redundancy and backup assembly.`
            default:
                return `Undefined Language`    
        }
    }

    getBotao2() {
        switch (this.idioma) {
            case 'br':
                return `Saiba mais`
            case 'us':
                return `Know more`
            default:
                return `Undefined Language`    
        }
    }

    getTextoRodape() {
        switch (this.idioma) {
            case 'br':
                return `As diretrizes e politicas de privacidade de informações de nossos clientes são entendidas como prioridade por toda equipe da City Connect. Desta forma não cedemos informações referentes a nossos clientes a terceiros.`
            case 'us':
                return `
                Our customers' information privacy policies and guidelines are understood as a priority by the entire City Connect team. In this way we do not give information about our customers to third parties.`
            default:
                return `Undefined Language`    
        }
    }

    getDireitosReservados() {
        switch (this.idioma) {
            case 'br':
                return `Todos os direitos reservados - @ City Connect`
            case 'us':
                return `All rights reserved - @ City Connect`
            default:
                return `Undefined Language`    
        }
    }

    getOsSystem() {
        switch (this.idioma) {
            case 'br': 
                return `Sistema de OS`
            case 'us':
                return `OS System`
            default: 
                return `Undefined Language`
        }        
    }

    getPassword() {
        
        switch (this.idioma) {
            case 'br':
                return `senha`
            case 'us':
                return `password`
            default:
                return `Undefined Language`
        }
    }

    getUsername() {
        switch (this.idioma) {
            case 'br':
                return `nome de usuário`
            case 'us':
                return `username`
            default:
                return `Undefined Language`
        }
    }

    getLogin() {
        switch (this.idioma) {
            case 'br':
                return `Entrar`
            case 'us':
                return `Sign in`
            default:
                return `Undefined Language`
        }
    }
}